module.exports = __webpack_public_path__ + "static/img/banner-v2.ad3f3a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner-v2.png
// module id = 7MBl
// module chunks = 0